import React from 'react';
import './Footer.css';

/**
 * Footer Component
 * Dashboard footer with copyright, version, and links
 */
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="dashboard-footer">
      <div className="footer-content">
        <div className="footer-left">
          <span className="copyright">© {currentYear} SeaZex. All rights reserved.</span>
          <span className="version">v2.0.0</span>
          <div className="trust-badges">
            <span className="trust-badge"><i className="fas fa-shield-alt"></i> Secure Escrow</span>
            <span className="trust-badge"><i className="fas fa-lock"></i> Encrypted</span>
            <span className="trust-badge"><i className="fas fa-check-circle"></i> Verified Providers</span>
          </div>
        </div>
        <div className="footer-right">
          <a href="#" className="footer-link">Privacy Policy</a>
          <a href="#" className="footer-link">Terms of Service</a>
          <a href="#" className="footer-link">Support</a>
          <a href="#" className="footer-link">Status</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;